import addHours from 'date-fns/addHours';
import addMinutes from 'date-fns/addMinutes';
import format from 'date-fns/format';
import subHours from 'date-fns/subHours';
import subMinutes from 'date-fns/subMinutes';
import styled from 'styled-components';

import { TimeChanger } from 'pkg/components/DateTimePicker/TimePicker/TimeChanger';

interface TimePickerProps {
  date?: Date;
  setDate?: (date: Date) => void;
}

const TimePickerContainer = styled.div`
  text-align: center;
  flex-grow: 1;
`;

const Header = styled.header`
  margin-bottom: 1rem;
`;

const Separator = styled.span`
  display: flex;
  align-items: center;
  font-size: 2.2rem;
`;

const AmPmSeparator = styled(Separator)`
  font-weight: 600;
  margin-top: -0.4rem;
`;

const TimeChangersContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 -0.75rem;
`;

export const TimePicker = ({ date, setDate }: TimePickerProps): JSX.Element => {
  if (!date || !setDate) {
    throw new Error('This component must be wrapped by DateTimePicker or explicitly be given props');
  }

  const [hours, minutes, amPm] = format(date, 'hh mm a').split(' ');
  const toggleAmPm = () => (amPm === 'AM' ? setDate(addHours(date, 12)) : setDate(subHours(date, 12)));

  return (
    <TimePickerContainer>
      <Header>
        <strong>Time</strong>
      </Header>
      <TimeChangersContainer>
        <TimeChanger
          addTime={() => setDate(addHours(date, 1))}
          subTime={() => setDate(subHours(date, 1))}
          time={hours}
        />
        <Separator>:</Separator>
        <TimeChanger
          addTime={() => setDate(addMinutes(date, 1))}
          subTime={() => setDate(subMinutes(date, 1))}
          time={minutes}
        />
        <AmPmSeparator>|</AmPmSeparator>
        <TimeChanger addTime={toggleAmPm} subTime={toggleAmPm} time={amPm} />
      </TimeChangersContainer>
    </TimePickerContainer>
  );
};
